import React from 'react';
import './style.scss';

const Button = ({ text, action }) => (
    <button onClick={e => { e.preventDefault(); action(); }} className='btn-component'>{text}</button>
);

export default Button;